import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../../services';
import styles from './StudyRequest.module.css';


const StudyRequestHeader = () => {
	const location = useLocation();
	const { t } = useTranslation();
  const isAdminPage = location.pathname === "/admin/study-request";

  return (
    <Typography variant="h5" component="h1" style={{display: "flex", alignItems: "center"}} className={styles.header}>
      <img
        src="/logo192.png"
        alt="Vicroty Drones logo"
        hidden={isAdminPage}
        className={styles.logo}
      />
      <span hidden={isAdminPage}>{t('Study request to course "Using Technology During War"')}</span>
    </Typography>
  )
};

export default StudyRequestHeader;
